
import React from 'react';
import BusinessLogo from './BusinessLogo';

interface BusinessCardContentProps {
  title: string;
  address: string;
  logoUrl?: string;
}

const BusinessCardContent: React.FC<BusinessCardContentProps> = ({ 
  title, 
  address,
  logoUrl
}) => {
  return (
    <div className="flex-1 flex items-center">
      <div className="flex-1 pl-2.5">
        <h3 className="text-base font-semibold text-gray-900">{title}</h3>
        <p className="text-sm text-gray-500 mt-0">{address}</p>
      </div>
      
      {logoUrl && <BusinessLogo logoUrl={logoUrl} title={title} />}
    </div>
  );
};

export default BusinessCardContent;
